import Input from 'Components/shared/Input'
import React from 'react'

export default ({ hook, placeholder }) => {
  return <Input fullWidth background="#fff" {...hook.bind} tabIndex={0} placeholder={placeholder} />
}
